import { graphql } from '@/gql';
import type { PartnerGeofenceContainsMutation, PartnerGeofenceContainsMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type PartnerGeofenceContainsInput = PartnerGeofenceContainsMutationVariables;

export type PartnerGeofenceContainsOutput = PartnerGeofenceContainsMutation['partnerGeofenceContains'];

export const partnerGeofenceContains = async ({ id, point }: PartnerGeofenceContainsInput): Promise<PartnerGeofenceContainsOutput> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation PartnerGeofenceContains($id: Float!, $point: PointInputType!) {
        partnerGeofenceContains(id: $id, point: $point)
      }
    `),
    variables: {
      id,
      point,
    },
  });

  return response.data!.partnerGeofenceContains;
};
